export default __webpack_public_path__ + "static/media/banner04.7ed9e688.png";